/**
 * API Configuration
 *
 * Uses VITE_API_BASE_URL environment variable if set,
 * otherwise falls back to localhost:3002 ONLY if NODE_ENV is 'development'.
 * Throws/logs error on missing configuration in production/staging.
 */

/**
 * Diagnostic info for API config.
 */
export const getApiConfigDiagnostics = () => ({
    envUrl: import.meta.env.VITE_API_BASE_URL,
    nodeEnv: import.meta.env.NODE_ENV,
    fallbackUsed: !import.meta.env.VITE_API_BASE_URL,
  });
  
  /**
   * Find the intended API base URL safely
   */
  const getApiBaseUrl = (): string => {
    const envUrl = import.meta.env.VITE_API_BASE_URL;
    const nodeEnv = import.meta.env.NODE_ENV;
  
    if (envUrl) {
      // Remove trailing slash if present and validate format
      return envUrl.replace(/\/$/, '');
    }
    if (nodeEnv === 'development') {
      // Warn in dev if env is missing
      console.warn(
        '[API CONFIG] VITE_API_BASE_URL missing — falling back to http://localhost:3001.'
      );
      return 'http://localhost:3001';
    }
    // Production or staging: throw error or log
    throw new Error(
      '[API CONFIG] VITE_API_BASE_URL missing! Check environment config.'
    );
  };
  
  export const API_BASE_URL = getApiBaseUrl();
  
  /**
   * Get full API URL for an endpoint.
   * Safely normalizes endpoint and prevents double slashes.
   * @param endpoint - API endpoint, e.g., '/api/members'
   * @returns Full normalized URL
   */
  export const getApiUrl = (endpoint: string): string => {
    // Normalize both base URL and endpoint
    const base = API_BASE_URL.replace(/\/$/, '');
    const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${base}${normalizedEndpoint}`;
  };
  